import type { Candle, Tick } from "../types";
import { backendGet } from "./Backend";

export function normalizeTick(symbol: string, epoch: unknown, price: unknown): Tick {
  return { symbol, time: Math.floor(Number(epoch)), price: Number(price) };
}

export function candleFromDeriv(c: Record<string, any>): Candle {
  const o = +c.open, h = +c.high, l = +c.low, cl = +c.close;
  return { time: +c.epoch, endTime: +c.epoch, open: o, high: h, low: l, close: cl, volume: 0, upTicks: 0, downTicks: 0 };
}

// Historical backfill through the Felacoo backend ticks_history proxy (≤5000 per request; default depth 5000).
export const HistoryLoader = {
  async ticks(symbol: string, count: number, opts: { start?: number; end?: number | "latest" } = {}): Promise<Tick[]> {
    const res = await backendGet<{ ticks: Tick[] }>("/market/history", { symbol, style: "ticks", count: Math.min(count, 5000), start: opts.start, end: opts.end });
    return (res.ticks || []).map((t) => normalizeTick(symbol, t.time, t.price));
  },

  async candles(symbol: string, granularity: number, count: number): Promise<Candle[]> {
    const res = await backendGet<{ candles: Candle[] }>("/market/history", { symbol, style: "candles", granularity, count: Math.min(count, 5000) });
    return res.candles || [];
  },
};
